// extracted by mini-css-extract-plugin
export default {"content":"PhoneInput__content--j5zlz"};